import { SeatStatus } from './team/seatStatus';

export class PositionListing {
  public id: string;
  public workspaceId: string;
  public positionId: string;
  public positionName: string;
  public formId: string;
  public formName: string;
  public teamName: string;
  public description: string;
  public opportunitySeatStartDate: Date;
  public opportunitySeatEndDate: Date;
  public listingDeadline: Date;
  public opportunitySeatStatus: SeatStatus;
  public opportunityBoardIds: string[] = [];

  constructor(
    id: string,
    workspaceId: string,
    positionId: string,
    formId: string,
    description: string,
    opportunitySeatStartDate: Date,
    opportunitySeatEndDate: Date,
    listingDeadline: Date,
    opportunitySeatStatus: SeatStatus,
    opportunityBoardIds: string[]
  ) {
    this.id = id;
    this.workspaceId = workspaceId;
    this.positionId = positionId;
    this.formId = formId;
    this.description = description;
    this.opportunitySeatStartDate = opportunitySeatStartDate;
    this.opportunitySeatEndDate = opportunitySeatEndDate;
    this.listingDeadline = listingDeadline;
    this.opportunitySeatStatus = opportunitySeatStatus;
    this.opportunityBoardIds = opportunityBoardIds;
  }

  static parse(obj: any): PositionListing {
    return new PositionListing(
      obj.id,
      obj.workspaceId,
      obj.positionId,
      obj.formId,
      obj.description,
      obj.opportunitySeatStartDate,
      obj.opportunitySeatEndDate,
      obj.listingDeadline,
      obj.opportunitySeatStatus,
      obj.opportunityBoardIds
    );
  }
}

export interface IPositionListing {
  id: string;
  workspaceId: string;
  positionId: string;
  teamFormId: string;
  description: string;
  seatStartDate: Date;
  seatEndDate: Date;
  listingDeadline: Date;
  seatStatus: SeatStatus;
}
